// Requires: src/namespace.js

window.BOL.RegisterProduct.showStepOneButtons = (function($) {
	'use strict';
	var $buttons = $('[data-step-action-btn]');
	var $buttonPromo = $('[data-promofields-button]');

	function toggleButtons(disabled) {
		if(disabled) {
		    $buttons.removeClass('disabled');
		    $buttonPromo.removeClass('disabled');
			return;
		}

		$buttons.addClass('disabled');
		$buttonPromo.addClass('disabled');
	}

	return {
		toggleButtons: toggleButtons
	};

})($jq);
